import axios from 'axios'

export const fetchOpengraphHandler = (url, callback) => {
  axios.get(`${appInfo.manageUrl}/scrap`, {
    params: {
      url: url
    }
  },
  {
    headers: {
      'Content-type': 'application/json'
    }
  })
    .then(res => res.data)
    .then(data => {
      if (data.requested_url.indexOf('.daum.net') > -1 && data.requested_url.indexOf('/videoog') > -1) {
        data.host = 'tv.kakao.com';
        data.source_url = data.url;
      }
      callback(data)
    })
}
